export const ProductReleaseTableColumnCaptions = {
  productName: 'Product name',
  productVersion: 'Product version',
  releaseDate: 'Release date',
  isFavorite: 'Favorite',
  productRelease: 'Product release',
};

export const ClientTableColumnCaptions = {
  legalForm: 'Legal form',
  formalName: 'Formal Name',
  fullName: 'Full name',
  name: 'Name',
  legalAddress: 'Legal address',
  taxId: 'Tax ID',
  contactPerson: 'Contact person',
  e_mail: 'E-mail',
  phone: 'Phone',
  isFavorite: 'Favorite',
};

export const OfflineLicenseColumnCaptions = {
  'device.key': 'Device key',

  key: 'License key',
  generationDate: 'Generation date and time',
  activationDate: 'Activation date',
  supportDayCount: 'Support day count',
  productName: 'Product name',
  connectionCount: 'Connection count',
  webConnectionCount: 'Web connection count',
  webExpirationDate: 'Web Viewer expiration date',
  webValidityTerm: 'Web validity term',
  livingState: 'Living state',
  supportExpirationDate: 'Support expiration date',
  maxProductVersion: 'Max version',
  isFavorite: 'Favorite',
  device: {
    key: 'Device key',
  },
  client: {
    fullName: 'Client',
  },
  type: {
    name: 'Type',
  },
  dicomConnectionLimitationType: 'Limitation type'
};

export const AccountsTableColumnCaptions = {
  login: 'Login',
  password: 'Password',
  device: {
    key: 'Device key',
  },
  deviceRelationExpirationDate: 'Device relation expiration date',
  provider: {
    key: 'AI Provider'
  },
  isSuper: 'Super account',
};

export const WebViewerServersTableColumnCaptions = {
  id: 'Id',
  key: 'Server key',
  productName: 'Product name',
  productVersion: 'Product version',
  generationDateTime: 'Generation date and time',
  activationDateTime: 'Activation date and time',
  expirationDateTime: 'Expiration date and time',
  linkConnectionCount: 'Link connection count',
  linkCount: 'Link count',
  usedLinkCount: 'Used link count',
  device: {
    key: 'Device key',
  },
  client: 'Client',
  livingState: 'Living state',
  isFavorite: 'Favorite',
  type: 'Type',
  connectionCount: 'Connection count',
};

export const WebViewerLicensesTableColumnCaptions = {
  id: 'Id',
  key: 'License key',
  generationDateTime: 'Generation date and time',
  activationDateTime: 'Activation date and time',
  server: {
    key: 'Server key',
  },
  connectionUid: 'Connection Uid',
  isFavorite: 'Favorite',
};

export const PermanentLicenseColumnCaptions = {
  key: 'License key',
  supportDayCount: 'Support day count',
  client: {
    fullName: 'Client',
  }
};

export const TemporaryLicenseColumnCaptions = {
  key: 'License key',
  term: 'Validity term',
  client: {
    fullName: 'Client',
  },
  obtainingMethod: 'Obtaining method'
};

export const TrialRejectedDevicesTableColumnCaptions = {
  device: {
    id: 'Device id',
    key: 'Device key',
  },
  isOn: 'Enabled',
};

export const TrialSettingsHistoryTableColumnCaptions = {
	minAllowedViewerVersion: 'Min Allowed Version',
	onceAYear: 'Once a year',
};

export const BanTableColumnCaptions = {
  id: 'Id',
  device: {
    id: 'Device id',
    key: 'Device key',
  },
  banStatus: 'Ban status',
};



// WEBPACK FOOTER //
// ./src/components/tableColumnCaptions.js